export default [
  { name: 'Pai' },
  { name: 'Mãe' },
  { name: 'Avô' },
  { name: 'Avó' },
  { name: 'Tio' },
  { name: 'Tia' }
]
